import { UserRole, type UserRoleType } from '@/api/admin-types'
import type { Translations } from '@/i18n/i18n-types'

const knownRoles = new Set<string>(Object.values(UserRole))

/** ADMIN-gated UI — DEVELOPER is a superset and can do anything ADMIN can. */
export function isAdminOrDeveloperRole(role: string | undefined): boolean {
	return role === UserRole.Admin || role === UserRole.Developer
}

/** Localized label for an invite JWT/API role; unknown values pass through for forward compatibility. */
export function inviteRoleLabel(role: string | undefined, L: Translations): string {
	if (role && knownRoles.has(role)) {
		return L.Enum.UserRole(role as UserRoleType)
	}
	if (role) return role
	return L.Enum.UserRole('USER')
}
